import axios from 'axios';

const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'https://api-dev.thrivesmart.com/' });

export default axiosServices;
